import { render, staticRenderFns } from "./Input.vue?vue&type=template&id=8c5ab2e6&scoped=true"
import script from "./Input.ts?vue&type=script&lang=ts&external"
export * from "./Input.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5ab2e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c5ab2e6')) {
      api.createRecord('8c5ab2e6', component.options)
    } else {
      api.reload('8c5ab2e6', component.options)
    }
    module.hot.accept("./Input.vue?vue&type=template&id=8c5ab2e6&scoped=true", function () {
      api.rerender('8c5ab2e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Forms/components/Input/Input.vue"
export default component.exports